import { jsxs, jsx } from 'react/jsx-runtime';
import { memo, useMemo } from 'react';
import 'lodash/isEqual';
import '../../node_modules/tslib/tslib.es6.js';
import 'lodash/get';
import 'lodash/orderBy';
import '@splitsoftware/splitio-react';
import { useConversationStarters } from '../../utils/hooks/useConversationStarters.js';
import { TextBox, SuggestionListWidget } from '@brandclub/bc-widgets';

const ConciergeWelcomeEmbeddedComponent = ({ displayQueries, isLoadingSuggestedQueries, onSearch, pageContext, apiBaseUrl, }) => {
    const pageType = pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageType;
    const stacklineSku = pageContext === null || pageContext === void 0 ? void 0 : pageContext.stacklineSku;
    // Fetch context-specific queries using the shared hook
    const { questions: contextQueries, isLoading: isLoadingContextQueries } = useConversationStarters({
        stacklineSku,
        apiBaseUrl,
        enabled: pageType === 'pdp' && !!stacklineSku,
    });
    // Use context queries if available, otherwise fall back to displayQueries
    const queriesToShow = useMemo(() => (contextQueries.length > 0 ? contextQueries : displayQueries), [contextQueries, displayQueries]);
    const isLoading = useMemo(() => isLoadingContextQueries || ((pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageType) === 'pdp' && isLoadingSuggestedQueries), [isLoadingContextQueries, pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageType, isLoadingSuggestedQueries]);
    return (jsxs("div", Object.assign({ style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px 16px',
            textAlign: 'center',
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
            overflow: 'auto',
        } }, { children: [jsx("div", Object.assign({ style: { marginBottom: '20px' } }, { children: jsx("div", Object.assign({ style: { margin: '0 0 8px 0' } }, { children: jsx(TextBox, { widgetId: "concierge-welcome-message", displayName: "Welcome Message", initialState: {
                            content: (pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageType) === 'pdp'
                                ? 'Get expert advice on this product'
                                : "Let us help you find what you've been looking for.",
                            fontSize: 24,
                            fontWeight: 'bold',
                            color: {
                                type: 'theme',
                                value: 'primary',
                            },
                            textAlign: 'center',
                            lineHeight: 1.2,
                            letterSpacing: 0,
                            textTransform: 'none',
                        } }) })) })), queriesToShow.length > 0 && !isLoading && (jsx(SuggestionListWidget, Object.assign({ widgetId: "concierge-suggestion-list", displayName: "Suggestion List" }, { children: (state, resolveColor) => (jsx("div", Object.assign({ style: {
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: `${state.containerGap}px`,
                        maxWidth: '100%',
                    } }, { children: queriesToShow.slice(0, 4).map((query, index) => (jsx("button", Object.assign({ onClick: () => {
                            // Product context wrapping is now handled in the parent (ConciergeWidgetChat)
                            // to avoid duplicating product info in every message
                            onSearch(query);
                        }, style: {
                            padding: `${state.pillPaddingY}px ${state.pillPaddingX}px`,
                            borderRadius: `${state.pillBorderRadius}px`,
                            border: `${state.pillBorderWidth}px solid ${resolveColor(state.pillBorderColor)}`,
                            backgroundColor: resolveColor(state.pillBgColor),
                            color: resolveColor(state.pillTextColor),
                            fontSize: `${state.pillFontSize}px`,
                            fontWeight: state.pillFontWeight === 'normal'
                                ? 400
                                : state.pillFontWeight === 'medium'
                                    ? 500
                                    : state.pillFontWeight === 'semibold'
                                        ? 600
                                        : 700,
                            fontFamily: state.pillFontFamilyCss || 'inherit',
                            cursor: 'pointer',
                            textAlign: 'left',
                            transition: 'all 0.2s ease',
                            width: '100%',
                        }, onMouseEnter: (e) => {
                            e.currentTarget.style.backgroundColor =
                                resolveColor(state.pillBgColorHover) || resolveColor(state.pillBgColor);
                        }, onMouseLeave: (e) => {
                            e.currentTarget.style.backgroundColor = resolveColor(state.pillBgColor);
                        } }, { children: query }), index))) }))) })))] })));
};
// Memoize to prevent re-renders when parent re-renders due to input changes
const ConciergeWelcomeEmbedded = memo(ConciergeWelcomeEmbeddedComponent);

export { ConciergeWelcomeEmbedded };
//# sourceMappingURL=ConciergeWelcomeEmbedded.js.map
